import React, { Component, Fragment } from 'react'
import moment from 'moment'
import numeral from 'numeral'
import SingleView from '../../components/SingleView'
import { Pagination } from 'antd'
import { drop } from 'lodash'

class PaymentRequests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1
    }
  }

  setPage = page => {
    this.setState({
      page
    })
  }

  getPagedData = () => {
    const { page } = this.state
    const data = this.props.paymentRequests
    const offset = (page - 1) * 10
    return drop(data, offset).slice(0, 10)
  }

  render() {
    return (
      <Fragment>
        <div className="jobsBar">Payment Requests</div>
        <SingleView
          title="Payment Requests"
          emptyText="No payment requests for this vendor"
          data={this.getPagedData()}
          getKey={c => c.id}
          getHeader={c => c.description}
        >
          {c => (
            <Fragment>
              <div className="row">
                <div className="col-md-2">
                  <div className="jobDetailsHeader">ID:</div>
                  <span>{c.id}</span>
                </div>
                <div className="col-md-6">
                  <div className="jobDetailsHeader">Description:</div>
                  <span>{c.description}</span>
                </div>
                <div className="col-md-4">
                  <div className="jobDetailsHeader">Due Date:</div>
                  <span>{moment.utc(c.due_date).format('M/D/YYYY')}</span>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <div className="jobDetailsHeader">Type:</div>
                  <span>{c.type}</span>
                </div>
                <div className="col-md-3">
                  <div className="jobDetailsHeader">Amount:</div>
                  <span>{numeral(c.amount).format('$0,0.00')}</span>
                </div>
                <div className="col-md-3">
                  <div className="jobDetailsHeader">Payable from:</div>
                  <span>{c.payable_from}</span>
                </div>
                <div className="col-md-2">
                  <div className="jobDetailsHeader">Payable to:</div>
                  <span>{c.payable_to}</span>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="jobDetailsHeader">Status:</div>
                  <span>{c.status}</span>
                </div>
              </div>
            </Fragment>
          )}
        </SingleView>
        <Pagination
          total={this.props.paymentRequests ? this.props.paymentRequests.length : 0}
          pageSize={10}
          current={this.state.page}
          defaultCurrent={1}
          onChange={this.setPage}
        />
      </Fragment>
    )
  }
}

export default PaymentRequests



// WEBPACK FOOTER //
// ./src/components/vendor/PaymentRequests.js